import { useState, useEffect } from "react";
import Select from "react-select";
import normalize from "../../utils/NormalizeSelect";

const MapFilter = ({ filter, setFilter, counts }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [companies, setCompanies] = useState([]);
  const [hasMore, setHasmore] = useState(true);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchDelivaryCompanies = (query = false) => {
    const total = companies.length;
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}delivery-company-options?page=${page}&limit=${limit}&search=${search}&totalData=${total}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (query === true) {
          if (res.data.code === 1) {
            setCompanies(res.data.data);
          }
        } else {
          if (res.data.code === 1 && res.data.data.length > 0) {
            setCompanies((prev) => {
              const existingIds = new Set(prev.map((c) => c._id));
              const newCompanies = res.data.data.filter(
                (c) => !existingIds.has(c._id)
              );
              return [...prev, ...newCompanies];
            });
          }
        }
        setHasmore(res.data.hasMore);
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchDelivaryCompanies(false);
  }, [page]);
  useEffect(() => {
    fetchDelivaryCompanies(true);
  }, [search]);

  return (
    <div className="position-absolute map-filter-wrapper">
      <div
        className="d-flex align-items-center theme-mode-wrapper"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
      >
        {/*begin::Menu toggle*/}
        <div
          style={{ cursor: "pointer" }}
          onClick={() => setOpenMenu((prev) => !prev)}
          className="btn btn-icon btn-light mb-2 shadow"
        >
          <i className="ki-duotone ki-filter fs-1">
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
        </div>
        {/*begin::Menu toggle*/}

        {/*begin::Menu*/}
        {openMenu && (
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-250px show map-filter-menu"
            data-kt-menu="true"
            data-kt-element="theme-mode-menu"
            data-popper-placement="bottom-end"
          >
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="notifications"
                      defaultChecked={filter?.activeBranch ?? false}
                      onChange={() =>
                        setFilter((prev) => ({
                          ...prev,
                          activeBranch: !prev.activeBranch,
                        }))
                      }
                    />
                    <label className="form-check-label">Active Branches</label>
                  </div>
                </div>
                <div>
                  {filter?.activeBranch && (
                    <div className="badge px-2 py-1 bg-primary text-light">
                      {counts?.activeBranch ?? 0}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      name="notifications"
                      defaultChecked={filter?.inactiveBranch ?? false}
                      onChange={() =>
                        setFilter((prev) => ({
                          ...prev,
                          inactiveBranch: !prev.inactiveBranch,
                        }))
                      }
                    />
                    <label className="form-check-label">
                      Inactive Branches
                    </label>
                  </div>
                </div>
                <div>
                  {filter?.inactiveBranch && (
                    <div className="badge px-2 py-1 bg-primary text-light">
                      {counts?.inactiveBranch ?? 0}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      name="notifications"
                      defaultChecked={filter?.availableDriver ?? false}
                      onChange={() =>
                        setFilter((prev) => ({
                          ...prev,
                          availableDriver: !prev.availableDriver,
                        }))
                      }
                    />
                    <label className="form-check-label">
                      Available Drivers
                    </label>
                  </div>
                </div>
                <div>
                  {filter?.availableDriver && (
                    <div className="badge px-2 py-1 bg-primary text-light">
                      {counts?.availableDriver ?? 0}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      name="notifications"
                      defaultChecked={filter?.inDeliveryDriver ?? false}
                      onChange={() =>
                        setFilter((prev) => ({
                          ...prev,
                          inDeliveryDriver: !prev.inDeliveryDriver,
                        }))
                      }
                    />
                    <label className="form-check-label">
                      In Delivery Drivers
                    </label>
                  </div>
                </div>
                <div>
                  {filter.inDeliveryDriver && (
                    <div className="badge px-2 py-1 bg-primary text-light">
                      {counts?.inDeliveryDriver ?? 0}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <input
                className="form-control"
                placeholder="Driver name or phone"
                value={filter?.driver ?? ""}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    driver: e.target.value,
                  }))
                }
              />
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <input
                className="form-control"
                placeholder="Search Branch name"
                value={filter?.branch ?? ""}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    branch: e.target.value,
                  }))
                }
              />
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <Select
                className="react-select-styled react-select-bordered"
                classNamePrefix="react-select"
                options={companies}
                filterOption={(option, input) => {
                  return normalize(option.label).includes(normalize(input));
                }}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={`${process.env.REACT_APP_API_PUBLIC_URL}${e.logo}`}
                      alt={e.name}
                      style={{
                        width: 24,
                        height: 24,
                        marginRight: 8,
                        borderRadius: "50%",
                      }}
                    />
                    {e.name}
                  </div>
                )}
                getOptionValue={(e) => e._id}
                filterOption={() => true}
                onInputChange={(value, action) => {
                  if (action?.action === "input-change") {
                    setSearch(value);
                    setPage(1);
                  }
                  if (action?.action === "menu-close") {
                    setSearch("");
                    setPage(1);
                  }
                }}
                onMenuScrollToBottom={() => {
                  if (hasMore) {
                    setPage((prev) => prev + 1);
                  }
                }}
                isClearable
                onChange={(e) => {
                  setFilter((prev) => ({ ...prev, deliveryCompany: e?._id }));
                }}
                value={companies?.find(
                  (item) => item?._id === filter?.deliveryCompany
                )}
                placeholder="Delivery company"
              />
            </div>
            {/*end::Menu item*/}
          </div>
        )}
        {/*end::Menu*/}
      </div>
    </div>
  );
};

export default MapFilter;
